import { Tabs } from "antd";
import { useEffect, useState } from "react";
import CMProfileTab from "./components/cm-profile-tab";
import DashboardTab from "./components/dashboard-tab";
import MemberDetailsTab from "./components/member-details-tab";
import configService from "@services/config.service";
import MemberListTab from "./components/member-list-tab";
import UserManagement from "./components/user-management/userManagement";
import { useUserManagement } from "@stores/userManagmentStore";
import LayoutOfDashboard from "@layout/defaultForDashboard";
import "./cm-admin.scss";

const CMAdmin = () => {
  const { TabPane } = Tabs;
  // Notification state
  // const [newNotificationFlag, setNewNotificationFlag] = useState(false);
  const [prefrences, setPrefrences] = useState<any>({});
  const [initial, setInitial] = useState<any>('');
  // const [notificationsData, setNotificationsData] = useState<any[]>([]);
  // const [loader, setLoader] = useState(false);
  const [updated, setUpdated] = useState(false);
  const setUserRole = useUserManagement((state) => state.setUserRole);
  useEffect(() => {
    console.log("CMAdmin.useEffect");
    const getPrefrences = () => {
      configService.getAppConfig().subscribe({
        next: (v) => {
          parsePrefrences(v.data.data?.[0]?.configOptions);
          setUserRole(v.data.data?.[0]?.role);
        },
        error: (e) => {
          // setLoader(false);
        },
        complete: () => { 
          // setLoader(false)
        },
      });
    }
  
    getPrefrences();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  const parsePrefrences = (pref: any) => {
    const config: any = {};
    pref.sort((p: any, q: any)=>{
      if(p.config_optn_order < q.config_optn_order){
        return -1;
      }
      if(p.config_optn_order > q.config_optn_order){
        return 1;
      }
      return 0;
    });
    pref.forEach((conf: any) => {
      if (!config[conf["config_optn_grp_name"]]) {
        config[conf["config_optn_grp_name"]] = [];
      }
      conf.config_optn_val = JSON.parse(conf.config_optn_val);
      config[conf["config_optn_grp_name"]].push(conf);
    });
    setPrefrences(config);
    setInitial(JSON.stringify(config));
  }

  const updatePrefrences = () => {
    const requestBody: any = {};
    Object.keys(prefrences).forEach((key: any)=>{
      prefrences[key].forEach((pref: any)=>{
        requestBody[pref.config_optn_id] = pref.config_optn_val;
      });
    });
    configService.updateAppConfig(requestBody).subscribe({
      next: (v) => {
        setInitial(JSON.stringify(prefrences));
        setUpdated(false);
      },
      error: (e) => {
        // setLoader(false);
      },
      complete: () => { 
        // setLoader(false)
      },
    });
    console.log('requestBody', requestBody);
  }

  const checkForUpdate = () => {
    const jsonCurrent = JSON.stringify(prefrences);
    if(jsonCurrent === initial){
      setUpdated(false);
    }else{
      setUpdated(true);
    }
  }

  const onTabChange = (tab: string, pref: any) => {
    let updated = Object.assign({}, prefrences);
    updated[tab].config_optn_val = pref;
    console.log('updated', updated);
    setPrefrences(updated);
    checkForUpdate();
  }

  return (
  <LayoutOfDashboard>
    <div>
      {/* Updated: {updated?'YES':'NO'}  */}
      {updated && <button onClick={updatePrefrences}>UPDATE</button>}
      <Tabs defaultActiveKey="1" className="cm-admin-tab-menu">
        {false && (<><TabPane tab="Member List" key="1" >
          <MemberListTab config={prefrences['member_list']} onChange={(pref: any)=>onTabChange('member_list', pref)}  />
        </TabPane>
        <TabPane tab="Member Details" key="2">
          <MemberDetailsTab  config={prefrences['member_detail']}  onChange={(pref: any)=>onTabChange('member_detail', pref)} />
        </TabPane>
        <TabPane tab="Dashboard" key="3">
          <DashboardTab  config={prefrences['dashboard']} />
        </TabPane>
        <TabPane tab="CM Profile" key="4">
          <CMProfileTab  config={prefrences['cm_profile']} />
        </TabPane></>) }
        <TabPane tab="User Management" key="5">
          <UserManagement  config={prefrences['cm_profile']} />
        </TabPane>
      </Tabs>
    </div>
    </LayoutOfDashboard>
  );
};

export default CMAdmin;
